const getters = {
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  sidebarCollapsed: state => state.app.sidebarCollapsed,
  menuList: state => state.user.menuList,
  permissions: state => state.user.permissions
}

export default getters
